export default __webpack_public_path__ + "upload/toothbrush.f62cb583.png";